import {AxiosInstance} from 'axios'
import {ItemsResponse, TagListRequestParam, TagParam,} from '/@src/models/api'
import {Tag, TagRelation} from "/@src/models/graphApi";

export function fetchTagList(
  api: AxiosInstance,
  params: TagListRequestParam
): Promise<ItemsResponse<Tag>> {
  return api.post('/tag/query', {
    kw:params.keyword,
    is_topic:params.isTopic,
    limit: params.limit,
    page: params.page,
    pagination: {
      "offset": (params.page-1)*params.limit,
      "first": params.limit
    }
  })
}

export function createTag(api: AxiosInstance, param: TagParam): Promise<Tag> {
  return api.post('/tag', {
    name: param.title||param.name,
    cover_url: param.cover||param.cover_url,
    description: param.description,
    is_topic: param.topic,
  })
}
export function editTag(api: AxiosInstance, param: Tag): Promise<Tag> {
  return api.put(`/tag`, {
    id:param.id,
    name: param.name,
    cover_url: param.cover_url,
    description: param.description,
    is_topic:param.is_topic
  })
}

export function deleteTag(api: AxiosInstance, id: number): Promise<Tag> {
  return api.delete(`/tag`,{
    data:{
      id:id
    }
  })
}
export function getTag(api: AxiosInstance, id: number): Promise<Tag> {
  return api.get(`/tag/${id}`,{
    headers:{
      'cache-control':'no-store'
    }
  })
}

export function updateTagRelations(api: AxiosInstance, contentId:number,kind:number,relations:TagRelation[]): Promise<Tag> {
  return api.post('/content/tagrelations',{
    item_id:contentId,
    item_kind:kind,
    tag_relations:relations
  })
}
